import css from 'styled-jsx/css';
import { colors, screen } from 'components/styles/variables';

export default css`
  .header {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    color: ${colors.BLACK};
    margin-bottom: 17px;
  }

  @media (min-width: ${screen.smMin}) {
    .header {
      font-size: 20px;
      margin-bottom: 27px;
    }
  }

  .listings-carousel {
    position: relative;
    width: 100% !important;
    height: 350px;
  }
`;
